module.exports = __webpack_public_path__ + "static/img/essential3-new.705a6540.png";